import setPass from './set-pass.vue'

export default setPass
